/**
 * Matches at least one @ symbol and at least one period symbol.
 * https://regexr.com/6pr78
 */
export const emailAddressRegex = /^\S+@\S+\.\S+$/;
